import { render, staticRenderFns } from "./m-materials.vue?vue&type=template&id=bf391902"
import script from "./m-materials.vue?vue&type=script&lang=js"
export * from "./m-materials.vue?vue&type=script&lang=js"
import style0 from "./m-materials.vue?vue&type=style&index=0&id=bf391902&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports